import React from "react";
import { Tabs, Typography, Row, Col } from "antd";
import { withRouter, Link } from "react-router-dom";
import {
  createCorporateAccountDetails,
  getCorporateAccountDetails,
  getCorporateAccountUserDetails,
  getCurrentCustomer
} from "api/api";
import LoadingIndicator from "components/LoadingIndicator";
import {displayError, displayGenericError} from "common/notifications";
import GeneralInfoTab from "components/GeneralInfoTab";
import DocumentUploadingTab from "components/DocumentUploadingTab";
import BrdgxButton from "components/BrdgxButton";
import MailIcon from "icons/MailIcon";
import CustomerAcceptanceForm from 'components/CustomerAcceptanceForm';

import "./VerificationPage.scss";
import GeneralIndividualInfoTab from "../components/GeneralIndividualInfoTab";
import {
  findSchedule,
  getIndustryCode,
  getOccupationCode,
  updateCustomerAccount,
  retrieveMyInfo,
  checkDocumentUploadedCorpCustomerAccount
} from "../api/api";
import DocumentIndividualUploadingTab from "../components/DocumentIndividualUploadingTab";
import CustomerAcceptanceIndividualForm from "../components/CustomerAcceptanceIndividualForm";
import GeneralCorpInfoTab from "../components/GeneralCorporatenfoTab";
import ScheduleCorporateInfo from "../components/ScheduleCorporateInfo";
import moment from "moment";
import FinalReviewForm from "../components/FinalReviewForm";
import Modal from "antd/es/modal";
import DocumentCorporateUploadingTab from "../components/DocumentCorporateUploadingTab";
import CorporateAccountUserItem from "../components/CorporateAccountUserItem";
import CorporateAccountUserItemAttachment from "../components/CorporateAccountUserItemAttachment";
import CustomerAcceptanceCorporateForm from "../components/CustomerAcceptanceCorporateForm";

export const MyinfoUrl = process.env.REACT_APP_MYINFO_URL;
export const MyinfoClientId = process.env.REACT_APP_MYINFO_CLIENT_ID;
export const MyinfoCallback = process.env.REACT_APP_MYINFO_CALLBACK;

const { Title, Text } = Typography;

class VerificationPage extends React.Component {
  state = {
    industryName:'',
    occupationName:'',
    customerAccount:{},
    isLoading: true,
    isMyInfoLoading: false,
    isMyInfo: false,
    myinfoCode: "",
    myInfo: {},
    corporateAccount: {},
    corporateAccountUsers: [],
    tab: 1,
    isSubmitted: false,
    accountStatus: this.props.accountStatus,
    displaySchedule: true,
    onboardingData:{}
  };

  constructor(props) {
    super(props);
  }

  errorMsg ='';

  componentDidMount() {
    // alert(MyinfoUrl);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    if(params.get('code') !== null && params.get('code') !== ''){
      this.setState({
        myinfoCode: params.get('code'),
        isMyInfo: true,
        isMyInfoLoading: true
      })
        retrieveMyInfo(params.get('code')).then(response => {

          this.setState({
            isMyInfoLoading: false,
            myInfo: response
          })
        }).catch(function (err) {
          console.debug(err);
          Modal.error({
            title: 'Error',
            content: "MyInfo is rejecting the request. Please try again or click \"Next\" to continue with manual input.",
            onOk: () => {window.location = "/pages/onboarding"}
          });
        });
    }else if(params.get('error') !== null && params.get('error') == 'access_denied'){
      // alert("Not able to retrieve data from MyInfo ");
      this.setState({
        isMyInfo: false
      })
      Modal.error({
        title: 'Error',
        content: "MyInfo is rejecting the request. Please try again or click \"Next\" to continue with manual input.",
      });
    }
    this.setState({
      isLoading: true
    });
    findSchedule().then(customer =>{
        this.setState({
          displaySchedule : customer.dateSelect == null
        })
    }).catch(displayGenericError);

    getCurrentCustomer()
      .then(customer => {
        if (customer.accountType === 'PERSONAL') {
          let tab = this.state.tab
          if(this.state.isMyInfo){
            tab = 3;
          } else{
            if ((customer && customer.status === 'PENDING') || this.props.accountStatus === 'PENDING' ||
                this.props.accountStatus === 'PENDING_ACCEPTANCE') {
              tab = 4;
            }
          }
          this.setState({
            isLoading: false,
            tab: tab,
            customerAccount: Object.assign(this.state.customerAccount, customer)
          }, () => {
            if (this.state.customerAccount.personalAccountDetails.industry != null) {
              getIndustryCode().then(response => {
                this.setState({
                  industryName: response.filter(s => s.code === this.state.customerAccount.personalAccountDetails.industry)[0].value
                });
              })
            }
            if (this.state.customerAccount.personalAccountDetails.occupation) {
              getOccupationCode().then(response => {
                this.setState({
                  occupationName: response.filter(s => s.code === this.state.customerAccount.personalAccountDetails.occupation)[0].value
                });
              })

            }
          });
        } else {
          getCorporateAccountDetails()
              .then(corporateAccount => {
                let tab = this.state.tab;
                //tab = 2
                // if (corporateAccount && corporateAccount.country) {
                //   tab = 2
                // }
                if (this.props.accountStatus === 'PENDING' || this.props.accountStatus === 'PENDING_ACCEPTANCE') {
                  tab = 6;
                }

                this.setState({
                  isLoading: false,
                  tab: tab,
                //  corporateAccount,
                  accountStatus: customer.status,
                  customerAccount: customer
                });

                if (corporateAccount.id) {
                  getCorporateAccountUserDetails(corporateAccount.id)
                      .then(corporateAccountUsers =>
                          this.setState({ corporateAccountUsers })
                      )
                      .catch(displayGenericError);
                }
              })
              .catch(displayGenericError);
        }

      })
      .catch(displayGenericError);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      accountStatus: nextProps.accountStatus
    });
  }

  nextTab = ({ isSubmitted }) => this.setState({
    tab: this.state.tab + 1
  });

  prevTab = () => {
    let nextTab = this.state.tab - 1;
    if (this.state.isMyInfo) {
      nextTab = 1;
    }
    this.setState({
      tab: nextTab
    })
  };

  validatePersonalInfo = (accountInfo) => {
    let personalAccountDetails = accountInfo.personalAccountDetails;
    if(personalAccountDetails) {
      if(!personalAccountDetails.company) {
        this.errorMsg = "Please enter Company";
      } else if (!personalAccountDetails.industry){
        this.errorMsg = "Please enter Industry";
      } else if (!personalAccountDetails.industry){
        this.errorMsg = "Please enter Industry";
      } else if (!personalAccountDetails.occupation){
        this.errorMsg = "Please enter Occupation";
      } else if (!personalAccountDetails.annualSalary){
        this.errorMsg = "Please enter Annual Income";
      } else if (!personalAccountDetails.sourceOfFunds){
        this.errorMsg = "Please enter Source Of Wealth";
      } else {
        this.errorMsg = "";
      }
    } else {
      this.errorMsg = "General Info is not correct";
    }
    if (this.errorMsg) {
      return false;
    }
    return true;
  }

  onMyInfoLoading = () => {
    this.setState({
      isLoading: true
    })
  }

  handleSubmitGeneralInformation = (data, isMyInfo) => {
    this.setState({
      isLoading: true
    })
    if(data.accountType ==='PERSONAL') {
      if (this.validatePersonalInfo(data)){
      updateCustomerAccount(data).then(personalAccount => this.setState({
        customerAccount: Object.assign(this.state.customerAccount, personalAccount),
        isMyInfo: isMyInfo
      }, () => {
        // alert(MyinfoUrl);
        if (isMyInfo) {
          this.setState({
            isLoading: true
          })
          var num = Math.floor(Math.random() * 10000) + 1;
          var attributesMyInfo = 'uinfin,name,aliasname,hanyupinyinname,hanyupinyinaliasname,sex,race,dob,nationality,passtype,passstatus,passexpirydate,regadd,employment,occupation';
          var newUrl = MyinfoUrl + "?client_id=" + MyinfoClientId + "&redirect_uri=" + MyinfoCallback + "&attributes="+attributesMyInfo+"&purpose=Brdgx Verification&state="+num;
          window.location = newUrl;
          //this.setState({
          //  isLoading: false
          //})
        } else {
          getIndustryCode().then(response => {
            this.setState({
              industryName: response.filter(s => s.code === this.state.customerAccount.personalAccountDetails.industry)[0].value
            });

            getOccupationCode().then(response => {
              this.setState({
                occupationName: response.filter(s => s.code === this.state.customerAccount.personalAccountDetails.occupation)[0].value,
                tab: 2,
                isLoading: false
              });
            })

          }).catch(error => {
            displayGenericError(error);
          });
        }
      })).catch(displayGenericError)
    } else {
        displayError(this.errorMsg);
      }
    }else{
      updateCustomerAccount(data).then(customerAccount => this.setState({
        customerAccount: customerAccount,
        tab: 2
      })).catch(displayGenericError)
    }
    this.setState({
      isLoading: false
    })
  };
  handleCorporateSubmit = () =>{
    findSchedule().then(customer =>{
      this.setState({
        displaySchedule : customer.dateSelect == null
      })
      this.nextTab(false);
    }).catch(displayGenericError);
  }
  handleSubmit = () => {
    this.setState({ isSubmitted: true });
  };
  redirectMain = () => {
    const { history } = this.props;
    history.push("/");
  };
  handleFieldChange=(data) =>{
    this.setState({
      customerAccount: Object.assign(this.state.customerAccount, data)
    })
 }
  updateOnboardingForm = (data)=>{
    this.nextTab(true);
    this.setState({
      onboardingData: data,
      isMyInfo:false
    })
  }
  verifiedCorpDocumentUploaded =() =>{
    checkDocumentUploadedCorpCustomerAccount().then(res=>{
      this.nextTab(true);
    }).catch(error => {
      displayGenericError(error);
    });
  }
  render() {
    const {
      isLoading,
      isMyInfoLoading,
      customerAccount,
      corporateAccount,
      corporateAccountUsers,
      tab
    } = this.state;
    const { id } = corporateAccount;

    if (isLoading) {
      return <LoadingIndicator />;
    }

    if (isMyInfoLoading) {
      return <LoadingIndicator />;
    }

    return(
      <div>
        <div className="bp-page-content bp-page-large verification-page">
          {this.state.customerAccount.accountType === 'PERSONAL'&&(
          <Tabs
            tabBarGutter={20}
            tabPosition="top"
            activeKey={`${this.state.tab}`}
            onChange={tab => this.setState({ tab })}
          >
            <Tabs.TabPane tab="1. General Info" key="1" disabled={tab === 3 || tab === 4}>
              {this.state.customerAccount.accountType === 'PERSONAL'&&(
              <GeneralIndividualInfoTab
                customerAccount={customerAccount}
                nextTab={this.nextTab}
                handleFieldChange={this.handleFieldChange}
                onSubmit={this.handleSubmitGeneralInformation}
                myInfoLoading={this.onMyInfoLoading}
                customer={this.props.customer}
                redirectMain={this.redirectMain}
              />)}
            </Tabs.TabPane>
            <Tabs.TabPane
              tab="2. Document Upload"
              key="2"
              disabled={!id || tab === 3}
              forceRender
            >
              <DocumentIndividualUploadingTab customerAccount={customerAccount} nextTab={this.nextTab}
                                              currentTab = {this.state.tab}
                                              updateOnboardingForm={this.updateOnboardingForm} prevTab={this.prevTab}/>

            </Tabs.TabPane>
            <Tabs.TabPane
              tab="3. Review status"
              key="3"
              disabled={!id }
              forceRender
            >

                {(this.state.customerAccount.accountType === 'PERSONAL' && customerAccount.referenceNumber )&&(
                    <CustomerAcceptanceIndividualForm
                        customerAccount={customerAccount}
                        industryName={this.state.industryName}
                        occupationName={this.state.occupationName}
                        nextTab={this.nextTab}
                        prevTab={this.prevTab}
                        onboardingData={this.state.onboardingData}
                        isMyInfo={this.state.isMyInfo}
                        myInfo={this.state.myInfo}
                        myinfoCode={this.state.myinfoCode}
                    />
                    )}

            </Tabs.TabPane>

            <Tabs.TabPane
                tab="4. Result"
                key="4"
                disabled={!id}
                forceRender
            >
            <FinalReviewForm  />


            </Tabs.TabPane>
          </Tabs>)}
          {this.state.customerAccount.accountType === 'CORPORATE' && (
              <Tabs
                  tabBarGutter={20}
                  tabPosition="top"
                  activeKey={`${this.state.tab}`}
                  onChange={tab => this.setState({tab})}
              >
                <Tabs.TabPane tab="1. General Info" key="1" disabled={tab === 3 || tab === 4}>
                  {this.state.customerAccount.accountType === 'CORPORATE' && (
                      <GeneralCorpInfoTab customerAccount={customerAccount}
                                          onSubmit={this.handleSubmitGeneralInformation}/>)}
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="2. Document Upload"
                    key="2"
                    disabled={!id || tab === 1}
                    forceRender>
                  <DocumentCorporateUploadingTab handleCorporateSubmit ={this.handleCorporateSubmit}
                                                 customerAccount={customerAccount} nextTab={this.nextTab}
                                                 prevTab={this.prevTab}
                                                 handleSubmit={this.nextTab} updateOnboardingForm={this.updateOnboardingForm}
                                                  />
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="3. Corporate User"
                    key="3"
                    disabled={!id }
                    forceRender>
                  <CorporateAccountUserItem corporateAccountUsers={this.state.corporateAccountUsers} prevTab={this.prevTab} handleSubmit={this.nextTab}/>
                </Tabs.TabPane>

                <Tabs.TabPane
                    tab="4. Corporate User Attachment"
                    key="4"
                    disabled={!id }>
                  <CorporateAccountUserItemAttachment corporateAccountUsers={this.state.corporateAccountUsers}
                                                      prevTab={this.prevTab} disabled={true}
                                                      handleSubmit={this.verifiedCorpDocumentUploaded}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="5. Review Status"
                              key="5"
                              disabled={!id}>
                  <CustomerAcceptanceCorporateForm customerAccount={customerAccount}
                                                  onboardingData={this.state.onboardingData}
                                                   corporateAccountUsers={this.state.corporateAccountUsers}
                                                   prevTab={this.prevTab}
                                                   nextTab={this.nextTab}/>
                </Tabs.TabPane>



                <Tabs.TabPane
                    tab="6. Result"
                    key="6"
                    disabled={!id}
                    forceRender
                >
                  <FinalReviewForm  />


                </Tabs.TabPane>

              </Tabs>


          )}
          {/*{(this.state.displaySchedule  && this.state.customerAccount.accountType === 'CORPORATE') &&(*/}
          {/*    <ScheduleCorporateInfo handleCorporateSubmit = {this.handleCorporateSubmit}/>)}*/}
        </div>
      </div>
  );
}
}

export default withRouter(VerificationPage);
